import DataLoader from 'dataloader';
// import * as companyService from '@api/company';
import * as companyService from '@api/company';
import { map } from 'rxjs/operators';
import { makeLoader, normalizeForLoader } from '@lib/common';
import { ExpiryMap } from '@lib/common/expiry-map';

/**
 * A helper class to expire the items stored in the
 * map after the desired amount of seconds. This will
 * return null if the item has expired. Mostly designed
 * for dataloader
 */

export const companyLoader = new DataLoader(
  (ids: string[]) =>
    companyService
      .filter_compact({
        filters: [
          {
            id: 'vtr_id',
            value: {
              $in: ids.join(','),
            },
          },
        ],
        pageSize: ids.length > 10 ? ids.length : 10,
      })
      .pipe(
        map(res => res.data.data),
        normalizeForLoader(
          ids,
          cmp => cmp.vtr_id,
          id => new Error(`No Company with id ${id}`)
        )
      )
      .toPromise(),
  {
    cacheMap: new ExpiryMap(120),
    maxBatchSize: 15,
  }
);

/**
 * Get company from a list of loaders.
 */
export const useCompanyLoader = makeLoader(companyLoader);
